import { LocalTaskProviderData } from "@jelly/lesson";
import course01 from "./course-01";
import course02 from "./course-02";
import course03 from "./course-03";
import course04 from "./course-04";
import course05 from "./course-05";

const data: LocalTaskProviderData = {
  byId: {
    ...course01.byId,
    ...course02.byId,
    ...course03.byId,
    ...course04.byId,
    ...course05.byId,
  },
  byLessonId: {
    ...course01.byLessonId,
    ...course02.byLessonId,
    ...course03.byLessonId,
    ...course04.byLessonId,
    ...course05.byLessonId,
  },
  expectedAnswerMetadata: {
    ...course01.expectedAnswerMetadata,
    ...course02.expectedAnswerMetadata,
    ...course03.expectedAnswerMetadata,
    ...course04.expectedAnswerMetadata,
    ...course05.expectedAnswerMetadata,
  },
};

export default data;
